import { css } from 'emotion'
// import { LINK_COLOR, LINK_COLOR_DARK  } from 'constants/styleConstants'

export const TaskSizeFieldStyles = css`
  .ActionButton {
    text-transform: none;
  }
`
